const STATUS_LABELS = {
  completed: 'Completed',
  failed: 'Failed',
  in_progress: 'In Progress',
  pending: 'Pending',
  timed_out: 'Timed out'
}

const TRIGGER_LABELS = {
  manual_expert: 'Manual (Expert)',
  manual_admin: 'Manual (Admin)',
  periodic: 'Periodic',
  published: 'Published',
  first_add: 'First Add',
  site_url_changed: 'Site URL Changed'
}

const STATUS_CLASSES = {
  completed: 'scan-status--completed',
  failed: 'scan-status--failed',
  in_progress: 'scan-status--in-progress',
  pending: 'scan-status--pending'
}

const ProjectWebscannerService = class ProjectWebscannerService {
  constructor ($http, Configuration) {
    'ngInject'

    this.$http = $http
    this.Configuration = Configuration
  }

  fetchLatestScan (projectId) {
    return this.$http
      .get(`${this.Configuration.apiUrl}/projects/${projectId}/scans/latest`)
      .then(response => response.data)
  }

  fetchScans (projectId) {
    return this.$http
      .get(`${this.Configuration.apiUrl}/projects/${projectId}/scans`)
      .then(response => response.data)
  }

  startScan (projectId) {
    return this.$http
      .post(`${this.Configuration.apiUrl}/projects/${projectId}/scans`)
      .then(response => response.data)
  }

  statusLabel (status) {
    return STATUS_LABELS[status] || status
  }

  triggerLabel (trigger) {
    return TRIGGER_LABELS[trigger] || trigger
  }

  statusClass (status) {
    return STATUS_CLASSES[status] || ''
  }

  performanceSummary (scan) {
    const desktop = scan?.summary?.performanceDesktop
    const mobile = scan?.summary?.performanceMobile
    if (!desktop && !mobile) return null
    if (!desktop) return mobile
    if (!mobile) return desktop
    return desktop.issues >= mobile.issues ? desktop : mobile
  }
}
export default ProjectWebscannerService
